import React from 'react'
import { Container, Image } from 'components/qstrap'
import intl from 'react-intl-universal'

const SearchNotFound = () => (
  <Container id="school-not-found" className="text-center">
    <div className="headline">
      {intl.get('search.no_schools_found')}
    </div>
    <div className="description">
      {intl.get('search.no_schools_found_description')}
    </div>
    <Image src="/assets/img/no_result.png" />
  </Container>
)

export default SearchNotFound
